module.exports = __webpack_public_path__ + "static/media/bgMobile.b1de59bf.svg";